import React, { type ChangeEvent } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";

import type { SelectionDataPipeline, SelectionStep } from "@/schemas/routing/selection-pipeline";
import { getStepsForCategory } from "@/utils/selection-pipeline";

export interface UnorderedCheckboxProps {
	readonly pipeline: SelectionDataPipeline;
	readonly category?: string;
	readonly name: string;
	readonly label: string;
	readonly conflictsWith?: string[];
	readonly preRequesites?: string[];
	readonly handleClick?: (e: ChangeEvent<HTMLInputElement>) => void;
	readonly pendoId: string;
}

export const UnorderedCheckbox: React.FC<UnorderedCheckboxProps> = ({
	pipeline,
	category,
	name,
	label,
	conflictsWith,
	preRequesites,
	handleClick,
	pendoId,
}) => {
	const steps = category ? getStepsForCategory(pipeline, category) : [];
	const names = steps.map((i: SelectionStep) => i.name);
	const stepConfigured = names.some((step: string) => step === name);
	const hasConflict = !stepConfigured && conflictsWith && names.some((n: string) => conflictsWith.includes(n));
	const preRequesiteNotMet = preRequesites && !names.some((n: string) => preRequesites.includes(n));

	return (
		<FormControlLabel
			control={
				<Checkbox
					disabled={Boolean(hasConflict || preRequesiteNotMet)}
					checked={stepConfigured}
					readOnly={handleClick === undefined}
					onChange={handleClick}
					data-pendoid={pendoId}
				/>
			}
			label={label}
		/>
	);
};
